__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "identity-portal";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(1108), __webpack_require__.e(2950), __webpack_require__.e(5882)]).then(function() { return function() { return __webpack_require__(1108); }; }); });
			register("react-relay", "12.0.0", function() { return Promise.all([__webpack_require__.e(3821), __webpack_require__.e(1202), __webpack_require__.e(2950), __webpack_require__.e(6263)]).then(function() { return function() { return __webpack_require__(1202); }; }); });
			register("react-router-dom", "5.3.0", function() { return Promise.all([__webpack_require__.e(8427), __webpack_require__.e(2950), __webpack_require__.e(8299)]).then(function() { return function() { return __webpack_require__(8427); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(7276).then(function() { return function() { return __webpack_require__(7276); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};